/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {RadioTile, TileGroup} from "@carbon/react";
import {
    makeSetDisplayChoiceAction,
    selectFormulaDisplayChoice
} from "../redux/formula_search_redux";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useCallback} from "react";
import {PER_100_CAL, PER_LITER, PER_BOTH} from "../../../../common/constants";


const FormulaDisplayChoice = () => {
    const dispatch = useDispatch();

    // only changing formula choice state should trigger re-render
    const formulaDisplayChoice = useSelector(selectFormulaDisplayChoice);

    const onDisplayChoiceChangeHandler = useCallback((selectedValue, event) => {
        dispatch(makeSetDisplayChoiceAction(selectedValue));
    },[dispatch]);

    return  <div className="formula-tile-group" id="formula-tile-group">
        <TileGroup
            defaultSelected={PER_100_CAL}
            legend="Display Format: &nbsp;"
            name="document-choice-group"
            valueSelected={formulaDisplayChoice}
            onChange={onDisplayChoiceChangeHandler}
        >
            <RadioTile id="per100cal-button" value={PER_100_CAL}>
                Per 100 Cal
            </RadioTile>
            <RadioTile id="perliter-button" value={PER_LITER}>
                Per Liter
            </RadioTile>
            <RadioTile id="both-button" value={PER_BOTH}>
                Both
            </RadioTile>
        </TileGroup>
    </div>
}

export default React.memo(FormulaDisplayChoice);